// extracted by mini-css-extract-plugin
export default {"item":"DeviceInfo_item__aHDAB","itemRow":"DeviceInfo_itemRow__7YCYw","revoke":"DeviceInfo_revoke__RM4Vm"};